import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    customer: {
      name: "",
      email: "",
      token: "",
      sapcode: ""
    }
  },
  mutations: {
    STORE_CUSTOMER_DATA: (state, customer) => {
      state.customer = customer;
    }
  },
  actions: {
    storeCustomerData({ commit }, user) {
      commit("STORE_CUSTOMER_DATA", user);
    }
  }
});
